<template>
  <div class="edit-user">
    <button class="btn orange-white" :title="title" @click="showModal = true"
            v-b-tooltip :class="{ 'btn-sm' : !isNew }"
    >
      <span v-if="isNew">{{ $t('_user_add') }}</span>

      <fa v-else fa-class="edit" />
    </button>

    <b-modal id="user-edit" v-model="showModal" :cancel-disabled="true"
             :ok-disabled="true" :title="modalTitle" :hide-footer="true"
    >
      <div class="tab-content">
        <div class="row">
          <radio-input label="_enabled" name="enabled" ref="enabled"
                       :options="enabledOptions" v-model="formData.enabled"
                       class="col-6 p-0"
          />

          <radio-input label="_is_manager" name="is_manager" ref="is_manager"
                       :options="isManagerOptions" v-model="formData.is_manager"
                       class="col-6 p-0"
          />

        </div>

        <hr>

        <radio-input label="_gender" name="gender" :options="genderOptions"
                     v-model="formData.gender" ref="gender"
        />

        <text-input label="_first_name" name="first-name" ref="firstName"
                    v-model="formData.first_name"
        />

        <text-input label="_last_name" name="last-name" ref="lastName"
                    v-model="formData.last_name"
        />

        <text-input label="_landline" name="landline" ref="landline"
                    v-model="formData.landline"
                    :placeholder="$t('create_account.phone_placeholder')"
        />

        <text-input label="_phone_number" name="phone" ref="mobilePhone"
                    v-model="formData.mobile_phone"
                    :placeholder="$t('create_account.phone_placeholder')"
        />

        <text-input label="_email" name="email" type="email" ref="email"
                    v-model="formData.email"
        />

        <text-input label="_email2" name="email2" type="email" ref="email2"
                    v-model="formData.email2" :required="false"
        />

        <hr/>

        <b-form-checkbox id="send-voucher-to-travellers"
                         name="send-voucher-to-travellers"
                         v-model="formData.send_voucher_to_travellers"
        >
          {{ $t('_notifyTravellers') }}
        </b-form-checkbox>

        <hr/>

        {{ $t('user.onlinePolicy.excludeNonFree') }} :

        <b-form-checkbox id="override_exlude_non_free" name="override_exclude_non_free"
                         v-model="formData.override_exclude_non_free"
        >
          {{ $t('user.onlinePolicy.overrideExcludeNonFree') }}
          <span v-if="companyExcludeNonFree !== null">
            ({{ companyExcludeNonFree | bool }})
          </span>
        </b-form-checkbox>

        <radio-input name="exclude_non_free" :options="excludeNonFreeOptions"
                     v-model="formData.exclude_non_free"
                     v-if="formData.override_exclude_non_free"
        />

        <hr/>

        {{ $t('user.onlinePolicy.maxPrice') }} :

        <b-form-checkbox id="override_max_price" name="override_max_price"
                         v-model="formData.override_max_price"
        >
          {{ $t('user.onlinePolicy.overrideMaxPrice') }}
          <span v-if="companyMaxPricePerRoom">
            ({{ companyMaxPricePerRoom | currency }})
          </span>
        </b-form-checkbox>

        <number-input name="max_price"
                      :is-price="true" v-model="formData.max_price" :required="false"
                      placeholder="Saisir le montant"
                      v-if="formData.override_max_price"
        />

        <b-alert v-if="message.display" :variant="message.type"
                 dismissible show class="col-md-12"
        >
          <p v-if="message.type === 'success'">
            {{ $t(message.content) }}
          </p>

          <ul v-else>
            <li v-for="error in errors" :key="error.id" class="error">
              <span class="label">
                {{ getErrorLabelTranslation(error.field) | capitalise }} :
              </span>

              {{ error.message }}
            </li>
          </ul>
        </b-alert>

        <div class="row justify-content-center" v-if="!success">
          <button class="text-center btn orange-white" @click="onSubmit">
            {{ $t('_validate') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import fa from '@/components/global/icon/fontAwesome'
import textInput from '@/components/frontoffice/form/baseInput/text'
import radioInput from '@/components/frontoffice/form/baseInput/radio'
import numberInput from '@/components/frontoffice/form/baseInput/number'

export default {
  components: {
    bModal,
    fa,
    textInput,
    radioInput,
    numberInput
  },

  props: {
    user: Object
  },

  data () {
    return {
      isNew: true,
      showModal: false,
      commonApi: new CommonApi(),
      genderOptions: [
        { value: 'male', label: '_male', selected: false },
        { value: 'female', label: '_female', selected: false }
      ],
      enabledOptions: [
        { value: true, label: '_yes', selected: false },
        { value: false, label: '_no', selected: false }
      ],
      isManagerOptions: [
        { value: true, label: '_yes', selected: false },
        { value: false, label: '_no', selected: false }
      ],
      excludeNonFreeOptions: [
        { value: true, label: '_yes', selected: false },
        { value: false, label: '_no', selected: false }
      ],
      formData: {
        email: null,
        email2: null,
        enabled: null,
        first_name: null,
        gender: null,
        id: null,
        is_manager: null,
        landline: null,
        last_name: null,
        mobile_phone: null,
        exclude_non_free: null,
        override_exclude_non_free: false,
        override_max_price: false,
        max_price: null,
        send_voucher_to_travellers: false
      },
      message: {
        display: false,
        type: null,
        content: ''
      },
      errors: [],
      labels: {
        gender: '_gender',
        firstName: '_first_name',
        lastName: '_last_name',
        landline: '_landline',
        mobilePhone: '_mobile_phone',
        phones: '_phone_number',
        email: '_email',
        email2: '_email2',
        isManager: '_is_manager',
        enabled: '_enabled'
      },
      success: false,
      companyMaxPricePerRoom: this.$store.getters['security/company'].maxPricePerRoom,
      companyExcludeNonFree: this.$store.getters['security/company'].excludeOnlineNonFreeCancellation
    }
  },

  created () {
    this.isNew = this.user === undefined
    this.initForm()
  },

  methods: {
    onSubmit () {
      this.message.display = false
      this.message.content = ''
      this.commonApi.editUser(this.formData).then(response => {
        response.data.success ? this.dealSuccess() : this.dealFailure(response.data.errors)
      })
    },

    dealSuccess () {
      this.message.type = 'success'
      this.message.content = `home.users.confirmMessage.${this.isNew ? 'create' : 'edit'}`
      this.message.display = true
      this.success = true
      setTimeout( () => {
        this.$emit('input')
        this.initForm()
        this.showModal = false
      }, 3000)
    },

    initForm () {
      if (this.isNew) {
        this.formData = {
          email: null,
          email2: null,
          enabled: null,
          first_name: null,
          gender: null,
          id: null,
          is_manager: null,
          landline: null,
          last_name: null,
          mobile_phone: null,
          exclude_non_free: null,
          override_exclude_non_free: false,
          override_max_price: false,
          max_price: null,
          send_voucher_to_travellers: false
        }
      } else {
        this.formData = this.user

        /*Object.keys(this.user).forEach(key => {
          if (!Object.keys(this.formData).includes(key))
            this.user[key] = null
        })*/

        for (let gender of this.genderOptions) {
          gender.selected = this.isGenderSelected(gender.value)
        }

        for (let bool of this.enabledOptions) {
          bool.selected = bool.value === this.formData.enabled
        }

        for (let bool of this.isManagerOptions) {
          bool.selected = bool.value === this.formData.is_manager
        }

        for (let bool of this.excludeNonFreeOptions) {
          bool.selected = bool.value === this.formData.exclude_non_free
        }
      }

      this.success = false
      this.message = {
        display: false,
        type: null,
        content: ''
      }
    },

    dealFailure (response) {
      this.message.type = 'danger'
      this.errors = []

      for (let fields in response) {
        if (response.hasOwnProperty(fields)) {
          let code = parseInt(response[fields])
          let message = this.$t('error.' + code)
          let listFields = []

          if (fields.indexOf(',') !== -1)
            listFields = fields.split(',')
          else
            listFields = [fields]

          for (let field of listFields) {
            this.errors.push({
              field: field,
              message: message
            })
          }
        }
      }

      this.message.display = true
    },

    isGenderSelected (value) {
      return this.convertGenderFormat(this.formData.gender) === value
    },

    convertGenderFormat (value) {
      let ret = ''

      switch (value) {
        case 'M.':
        case 'm':
        case 'male':
        case 'M':
          ret = 'male'
          break
        case 'Mme':
        case 'f':
        case 'female':
        case 'F':
          ret = 'female'
          break
      }

      return ret
    },

    getErrorLabelTranslation (field) {
      return this.$t(this.labels[field])
    }
  },

  computed: {
    title () {
      return this.isNew ? '' : this.$t('_edit')
    },

    modalTitle () {
      return this.isNew ? this.$t('user.add.default') : this.$t('user.edit.default')
    }
  }
}
</script>
